import React from 'react';

import CreditsIcon from '@repo/ui/components/Icon/CreditsIcon';
import { Tooltip, TooltipPlacement } from '@repo/ui/components/Tooltip';
import { H6 } from '@repo/ui/components/Typography';
import { themeStyle } from '@repo/ui/theming';

import { CreditsWrapper } from './styles';

interface CreditsCostProps {
  cost: number;
  color?: string;
}

const CreditsCost: React.FC<CreditsCostProps> = ({ cost, color }) => {
  return (
    <Tooltip
      data-testid="credit-cost"
      offsetX={30}
      offsetY={-10}
      placement={TooltipPlacement.Left}
      text="AI Credits used"
    >
      <CreditsWrapper alignItems="center" gap="2px">
        <CreditsIcon
          height="12px"
          theme={{ color: color || themeStyle.varInkMedium }}
        />
        <H6 color={color || themeStyle.varInkMedium}>{cost}</H6>
      </CreditsWrapper>
    </Tooltip>
  );
};

export default CreditsCost;
